<template>
  <b-row class="animated fadeIn justify-content-center">
    <b-col md="6" xl="5">

      <b-alert :show="errors.any()" variant="danger" class="px-4">
        <ul class="m-0 px-1">
          <li v-for="err in errors.all()" :key="err">{{err}}</li>
        </ul>
      </b-alert>

      <b-card :header="$t('account.ChangePassword')">
        <b-form-group>
            <b-input-group :prepend="$t('account.CurrentPassword')">
              <b-form-input
                v-model="model.currentPassword"
                type="password"
                :name="$t('account.CurrentPassword')"
                v-validate="'required|min:6'"/>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-input-group :prepend="$t('account.NewPassword')">
              <b-form-input
                v-model="model.newPassword"
                type="password"
                :name="$t('account.NewPassword')"
                v-validate="'required|min:6|confirmed:pwdcfrm'"/>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-input-group :prepend="$t('users.PasswordConfirm')">
              <b-form-input
                v-model="pwdcfrm"
                type="password"
                ref="pwdcfrm"/>
            </b-input-group>
          </b-form-group>
          <b-btn block :disabled="progressing" @click.prevent="submit" variant="success">
            {{$t('shared.Save')}}
          </b-btn>
      </b-card>
      <h2 style="color:red"></h2>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'change-password',
  data () {
    return {
      progressing: false,
      model: {
        currentPassword: null,
        newPassword: null
      },
      pwdcfrm: null
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.progressing = true
          this.$api.account.changePassword(this.model.currentPassword, this.model.newPassword, true)
          .then(res => {
            this.$showSuccess(this.$t('account.YourPasswordHasChanged'))
            this.progressing = false
          }).catch(err => {
            this.$showError(this.$getLocaleErrorMessage(err, 'account'))
            this.progressing = false
          })
        }
      })
    }
  }
}
</script>
